<div class="flex layout-row place-center-center gap-xxl">
  <span class="flex"></span>

  <!-- Date Switcher -->
  <elder-date-switcher
    [date]="activeDate$ | async"
    (valueUpdated)="activeDate = $event"
    [datePickerEnabled]="true"
  >
  </elder-date-switcher>

  <span class="flex"></span>
</div>
